import StudentsIcon from '@BUP/assets/Images/Data/students_icon.svg'
import { useTranslation } from 'react-i18next'
import styles from './work-group.module.scss'
import PageLayout from '@BUP/components/Layout/Page'
import SubtitleDashboard from '@BUP/components/Generics/SubtitleDashboard'
import { Navigate, useLocation } from 'react-router-dom'
import WorkGroupComponent from '@BUP/components/SociogramDashboard/workgroupComponent'
import CollapsePanel from '@BUP/components/Generics/CollapsePanel'
import { handleSchoolgrades } from '@BUP/services/BraveUp'
import { useContext } from 'react'
import { OrganizationContext } from '@BUP/contexts/OrganizationContext'
import PopoverComponent from '@BUP/components/Generics/popover'

const WorkGroupPage = () => {
  const i18n = useTranslation()
  const { state: stateLocation } = useLocation()
  const organization = useContext(OrganizationContext)
  const organizationResults = stateLocation?.organizationResults

  if (!organizationResults) {
    return <Navigate to='/sociogram' replace />
  }

  const { locale } = organization.location

  const schoolGrades = handleSchoolgrades(locale)

  const capitalizeFirst = (label) => {
    const labelTag = i18n.t(`common.resources.${label}`)
    return labelTag.charAt(0).toUpperCase() + labelTag.slice(1)
  }
  const groupedByNivelAndCourse = organizationResults.reduce((acc, item) => {
    const { survey, courseId } = item
    const { courses } = survey
    const course = courses.find(course => course.id === parseInt(item.courseId, 10))

    const nivel = course?.tags?.find(tag => tag.startsWith('nivel:')) || 'nivel:unknown'
    if (!acc[nivel]) {
      acc[nivel] = {}
    }
    if (!acc[nivel][courseId]) {
      acc[nivel][courseId] = []
    }
    acc[nivel][courseId].push(item)
    return acc
  }, {})

  return (
    <PageLayout>
      <div className={styles.container}>
        <SubtitleDashboard
          icon={StudentsIcon}
          text={i18n.t('pages.data.dashBoardSociogram.teacher.toolTitle')}
        />
        <p>
          {i18n.t('pages.data.dashBoardSociogram.teacher.description')}{' '}
          <PopoverComponent
            title={i18n.t('pages.data.dashBoardSociogram.teacher.mediatorsGroupTitle')}
            description={i18n.t('pages.data.dashBoardSociogram.teacher.mediatorsGroupDescription')}
            name='mediadores'
            color='#d2c2f0'
          />
          ,{' '}
          <PopoverComponent
            title={i18n.t('pages.data.dashBoardSociogram.teacher.newLinksGroupTitle')}
            description={i18n.t('pages.data.dashBoardSociogram.teacher.newLinksGroupDescription')}
            name='nuevos vínculos'
            color='#d2c2f0'
            placement='bottom'
          /> {i18n.t('common.resources.generic.connectors.and')} {' '}
          <PopoverComponent
            title={i18n.t('pages.data.dashBoardSociogram.teacher.preferencesGroupTitle')}
            description={i18n.t('pages.data.dashBoardSociogram.teacher.preferencesGroupDescription')}
            name='preferencias'
            color='#d2c2f0'
            placement='right'
          />.
        </p>
        <div className={styles.nivel_wrapper}>
          {Object.entries(groupedByNivelAndCourse)
            .map(([nivelId, courses]) => {
              const nivelName = schoolGrades.find(elem => elem.id === nivelId)?.name

              return (
                <div className={styles.nivel_section} key={nivelId}>
                  <h2>{`${capitalizeFirst('course.attributes.tags.nivel.label')} ${nivelName}`}</h2>
                  {Object.entries(courses).map(([courseId, results]) => {
                    const { courses: coursesSurvey } = results[0].survey
                    const foundCourseName = coursesSurvey.find(elem => elem.id === parseInt(courseId, 10))?.name || i18n.t('common.resources.generic.unknown.course')

                    return (
                      <CollapsePanel key={courseId} bgColor='#ecfdf5' label={<h2>{`${capitalizeFirst('course.label')} ${foundCourseName}`}</h2>}>
                        <div key={courseId} className={styles.nivel_wrapper}>
                          <div className={styles.courses_wrapper}>
                            {results.map((result, index) => {
                              return (
                                <div key={result.id} className={styles.workgroups_container}>
                                  <h2>{capitalizeFirst('sociogram.label')} {index + 1}</h2>
                                  <WorkGroupComponent
                                    key={result.id}
                                    dataGroups={result.newGroups.groups}
                                  />
                                </div>
                              )
                            }
                            )}
                          </div>
                        </div>
                      </CollapsePanel>
                    )
                  })}
                </div>
              )
            })}
        </div>
      </div>
    </PageLayout>
  )
}

export default WorkGroupPage
